import { Component, OnInit, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../src/app/ncs/services/spinner.service';
import { ActorService } from '../../../src/app/ncs/services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController } from '../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../src/app/ncs/models/appdata';
import { ApiResponseModel } from '../../../src/app/ncs/models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { xLoginResponse } from '../../../src/app/ncs/models/login/loginresponsemodel';



@Component({
  selector: 'registerpagenrh',
  templateUrl: './registerpagenrh.component.html',
  styleUrls: ['./registerpagenrh.component.scss'] 
 
})

export class RegisterPageNRHComponent implements OnInit,  AfterViewInit  {
  ngAfterViewInit(): void {


    //$.getScript('./healins-assets/js/jquery.min.js');
    //$.getScript('./healins-assets/js/popper.min.js');
    //$.getScript('./healins-assets/js/bootstrap.min.js');
    //$.getScript('./healins-assets/js/starr.js');
    //$.getScript('./healins-assets/js/fontawesome-all.js');

    //mh.
   
  }
 

  public isRequesting: boolean = false;

  public ApiResData: ApiResponseModel;

  public IncialLogin: xLoginResponse


  public IncialApiResData: ApiResponseModel

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService,
    private modalService: NgbModal) { }

  ngOnInit() {
    //localStorage.clear();
    //AppData.Instance().UserLoginDetails = this.IncialLogin;
    if (AppData.Instance().IsSessionExits === true) {

      localStorage.clear();
      AppData.Instance().UserLoginDetails = this.IncialLogin;
      this.ApiResData = this.IncialApiResData;
    }

  }

  onSignIp() {
    //alert("going to login");
    this.router.navigate(['signinpage']);
    //let options: NgbModalOptions = {
    //  windowClass: 'center-dialog',
    //   backdrop : 'static',
    //  keyboard: false
    //};

    //const modalRef = this.modalService.open(NgbSignInModal, options);//, options)

    
    //window.open("http://www.google.com");
   

  }
  onSignUp() {
    this.router.navigate(['signuppage']);
    //let options: NgbModalOptions = {
    //  windowClass: 'center-dialog',
    //  backdrop: 'static',
    //  keyboard: false,
    //  //size: 'lg'
    //};

    //const modalRef = this.modalService.open(NgbSignUpModal, options)


  }
  onSignUpreg() {
    this.router.navigate(['signupreg']);
   


  }
  onSignUphos() {
    this.router.navigate(['signuphos']);



  }

  onlogin() {
   
    this.router.navigate(['signinpage']);
      //, { relativeTo: this.route.parent }
 
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }




}
